(function () {
  'use strict';

  var cracked = false;

  function spawnParticles(container) {
    var colors = ['#f5ead0', '#fbbf24', '#f0e8cc', '#d8c898', '#faf6ee'];
    for (var i = 0; i < 14; i++) {
      var p = document.createElement('div');
      p.className = 'qn-ph-particle';
      var size = Math.random() * 8 + 4;
      var angle = Math.random() * 360 * Math.PI / 180;
      var dist = Math.random() * 70 + 30;
      var tx = 'translate(' + Math.round(Math.cos(angle) * dist) + 'px,' + Math.round(Math.sin(angle) * dist) + 'px) scale(0)';
      p.style.cssText = [
        'width:' + size + 'px',
        'height:' + size + 'px',
        'background:' + colors[Math.floor(Math.random() * colors.length)],
        'left:calc(50% - ' + (size / 2) + 'px)',
        'top:calc(50% - ' + (size / 2) + 'px)',
        '--tx:' + tx,
        'animation-delay:' + (Math.random() * 0.1) + 's'
      ].join(';');
      container.appendChild(p);
      setTimeout(function (el) { el.remove(); }, 800, p);
    }
  }

  window.qnCrackEgg = function () {
    if (cracked) return;
    cracked = true;

    var container = document.getElementById('qnEggContainer');
    var restoreBtn = document.getElementById('qnRestoreBtn');
    if (!container) return;

    container.classList.add('shake');

    setTimeout(function () {
      container.classList.remove('shake');
      container.classList.add('cracked');
      spawnParticles(container);
      if (restoreBtn) restoreBtn.style.display = 'inline-block';
    }, 350);
  };

  window.qnRestoreEgg = function () {
    cracked = false;
    var container = document.getElementById('qnEggContainer');
    var restoreBtn = document.getElementById('qnRestoreBtn');
    if (!container) return;

    container.classList.remove('cracked');

    var svg = container.querySelector('.qn-ph-egg-svg');
    if (svg) {
      svg.style.animation = 'none';
      setTimeout(function () {
        svg.style.animation = '';
      }, 50);
    }

    if (restoreBtn) restoreBtn.style.display = 'none';
  };

  window.qnPickVar = function (el) {
    var price = el.getAttribute('data-price');
    var units = el.getAttribute('data-units');
    var priceEl = document.getElementById('qn-promo-price');

    document.querySelectorAll('.qn-ph-var').forEach(function (v) {
      v.classList.remove('active');
    });

    el.classList.add('active');

    if (priceEl && price) {
      priceEl.textContent = '$' + price;
    }

    // Actualiza la cantidad de huevos según el tamaño elegido (ej. Extra Grandes = 20).
    if (units) {
      document.querySelectorAll('.qn-ph-units').forEach(function (u) {
        u.textContent = units;
      });
      var eggCount = document.getElementById('qnEggCount');
      if (eggCount) {
        var word = eggCount.getAttribute('data-word') || 'huevos';
        eggCount.textContent = units + ' ' + word;
      }
    }
  };

})();